import { render, staticRenderFns } from "./ContactRelationships.vue?vue&type=template&id=f1f5cfda&scoped=true&lang=pug"
import script from "./ContactRelationships.vue?vue&type=script&lang=js"
export * from "./ContactRelationships.vue?vue&type=script&lang=js"
import style0 from "./ContactRelationships.vue?vue&type=style&index=0&id=f1f5cfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f5cfda",
  null
  
)

export default component.exports